var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuspended(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AC-\\u5171\\u901A\\u753B\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AC08-\\u5229\\u7528\\u505C\\u6B62\\u4E2D",
    transform: "translate(-670.000000, -367.000000)",
    stroke: "#C4D4E3",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(670.000000, 367.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 50,
    cy: 50,
    r: 49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 29,
    y: 45,
    width: 42,
    height: 10
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspended);
export default __webpack_public_path__ + "static/media/suspended.1286d760fdc7dfe2594e095d80149552.svg";
export { ForwardRef as ReactComponent };